// Vendors
import { useRef, useState } from 'react';
// Classes
import { WebSocketsClass } from 'classes/websocket/websocket';
// Event handlers
import { WebSocketHandlers } from 'handlers/websocket.handlers';
// Types
import { WebsocketHookType } from 'hooks/types/websocket.hook.type';

const useWebsocketHook = (): WebsocketHookType => {
  const [websocketConnected, setWebsocketConnected] = useState(false);

  const websocketRef = useRef<WebSocketsClass | null>(null);

  const handlers = WebSocketHandlers({
    websocketRef,
    setWebsocketConnected,
  });

  return { ...handlers, websocketConnected };
};

export { useWebsocketHook };
